








































































import { Vue, Prop, Component } from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import MainButton from '@/shared/buttons/main-button.component.vue';
import DateFormat from '@/shared/utils/date-format';
import BillingService from '@/domain/billing/service/billing.service';
import BillingInfoContent from './billing-info-content.component.vue';
import BillingDetailed from '../../../domain/billing/entity/billing-detailed.entity';

@Component({
  components: {
    MainButton,
    BillingInfoContent,
  },
})
export default class BillingInfo extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  billingId!: string;

  @Prop({
    type: String,
    default: '',
  })
  businessUnitId!: string;

  private loading: boolean = true;

  private billing: BillingDetailed = new BillingDetailed();

  get lastUpdate(): string {
    return (this.billing.updatedAt !== '' && this.billing.updatedAt !== undefined) ? DateFormat.fullDateAndTime(this.billing.updatedAt) : '';
  }

  go(path: string): void {
    this.$router.push(path);
  }

  private loadBillingDetails(): void {
    this.loading = true;
    BillingService.getById(this.billingId)
      .then((billing: BillingDetailed) => {
        this.billing = billing;
      })
      .catch(VbSnackbarService.handleHttpError)
      .finally(() => { this.loading = false; });
  }

  created() {
    this.loadBillingDetails();
  }
}
